import {createApp} from "vue";
import App from "@/App";

const app = createApp(App);

export default app;
